export { initializeAmplitude, trackAction, trackPageView } from './amplitude';
